import React, { useState, useEffect } from "react";
import classnames from "classnames";
import { createSelector } from "reselect";
// hooks
import { useRedux } from "../../../hooks/index";

// actions
import {
  toggleUserDetailsTab,
  toggleFavouriteContact,
  getChatUserDetails,
  toggleArchiveContact,
  setProfileActiveTab
} from "../../../redux/actions";

// components
import AudioCallModal from "../../../components/AudioCallModal";
import VideoCallModal from "../../../components/VideoCallModal";
import AppSimpleBar from "../../../components/AppSimpleBar";
import Loader from "../../../components/Loader";
import ProfileUser from "./ProfileUser";
import Actions from "./Actions";
import BasicDetails from "./BasicDetails";
import Groups from "./Groups";
import Media from "../../../components/Media";
import AttachedFiles from "../../../components/AttachedFiles";
import Status from "./Status";
import Members from "./Members";
import InviteCode from "./InviteCode";
import { USER_DETAILS_TABS } from "../../../redux/chats/types";
import { Button, Collapse } from "reactstrap";
import { Badge } from "react-bootstrap";
import { Utils } from "helpers/utils";
import { erpGetPrevTopNoVolume, UserTypes } from "api";
import ErpTopics from "./ErpTopics";
import SearchChats from "./SearchChat";
import ContentUploadSlipCore from "../Content/ContentUploadSlipCore";
// import "bootstrap/dist/css/bootstrap.min.css";

interface IndexProps {
  isChannel: boolean;
}
const Index = ({ isChannel }: IndexProps) => {
  // global store
  const { dispatch, useAppSelector } = useRedux();

  const errorData = createSelector(
    (state: any) => state.Chats,
    (state: any) => state.Profile2,
    (state, p2) => ({
      curUserType: p2.userType,
      chatUserDetails: state.chatUserDetails,
      getUserDetailsLoading: state.getUserDetailsLoading,
      isOpenUserDetails: state.isOpenUserDetails,
      isOpenUserDetailsTab: state.isOpenUserDetailsTab,
      isFavouriteContactToggled: state.isFavouriteContactToggled,

    })
  );
  // Inside your component
  const {
    curUserType
    , chatUserDetails, getUserDetailsLoading
    , isOpenUserDetails, isOpenUserDetailsTab, isFavouriteContactToggled
  } = useAppSelector(errorData);

  useEffect(() => {
    if (isFavouriteContactToggled) {
      dispatch(getChatUserDetails(chatUserDetails.id));
    }
  }, [dispatch, isFavouriteContactToggled, chatUserDetails.id]);

  /*
  close tab
  */
  const onCloseUserDetails = () => {
    dispatch(toggleUserDetailsTab(false));
  };

  /*
  video call modal
  */
  const [isOpenVideoModal, setIsOpenVideoModal] = useState<boolean>(false);
  const onOpenVideo = () => {
    setIsOpenVideoModal(true);
  };
  const onCloseVideo = () => {
    setIsOpenVideoModal(false);
  };

  /*
  audio call modal  
  */
  const [isOpenAudioModal, setIsOpenAudioModal] = useState<boolean>(false);
  const onOpenAudio = () => {
    //console.log('UserProfilesDetails.onOpenAudioClick');
    setIsOpenAudioModal(true);
  };
  const onCloseAudio = () => {
    setIsOpenAudioModal(false);
  };

  /*
  favourite
  */
  const onToggleFavourite = () => {
    dispatch(toggleFavouriteContact(chatUserDetails.id));
  };

  /*
  archive
  */
  const onToggleArchive = () => {
    dispatch(toggleArchiveContact(chatUserDetails.id));
  };

  const [isOpenUserDetailsTab2, setIsOpenUserDetailsTab2] = useState<any>(isOpenUserDetailsTab);
  // console.log('isOpenUserDetailsTab2 = ' + isOpenUserDetailsTab2);
  // useEffect(() => { console.log('isOpenUserDetailsTab = ' + isOpenUserDetailsTab); }, [isOpenUserDetailsTab]);
  // useEffect(() => { console.log('isOpenUserDetailsTab2:' + isOpenUserDetailsTab2) }, [isOpenUserDetailsTab2]);

  const activeTabErp = curUserType == UserTypes.Employee && isOpenUserDetailsTab2 == USER_DETAILS_TABS.ERP;
  const activeTabSearch = isOpenUserDetailsTab2 == USER_DETAILS_TABS.SEARCH;
  const activeTabSlip = isOpenUserDetailsTab2 == USER_DETAILS_TABS.SLIP;
  const activeTabProfile = !activeTabErp && !activeTabSearch && !activeTabSlip;


  const onTabClick = async (tab: USER_DETAILS_TABS) => {
    try {
      // setIsOpenUserDetailsTab2(tab); --> move to useEffect bellow
      dispatch(setProfileActiveTab(tab));
    } catch (e) {
      console.error(e);
      alert((e as any).message);
    }
  }

  useEffect(() => {
    setIsOpenUserDetailsTab2(isOpenUserDetailsTab);
  }, [isOpenUserDetailsTab]);

  const ToggleButton = () => {
    return (
      <ul className="nav nav-tabs" style={{ flexWrap: "nowrap", overflow: "hidden" }}>
        <li className="nav-item">
          <a style={{ whiteSpace: "nowrap", padding: "6px 10px" }} className={classnames("nav-link tab-header", { "active": activeTabProfile })} href="#" onClick={() => onTabClick(USER_DETAILS_TABS.Profile)}>
            {/* <i className='bx bx-info-circle'></i>  */}
            🧿โปรไฟล์</a>
        </li>
        <li className="nav-item">
          <a style={{ whiteSpace: "nowrap", padding: "6px 10px" }} className={classnames("nav-link tab-header", { "active": activeTabSlip })} href="#" onClick={() => onTabClick(USER_DETAILS_TABS.SLIP)}>
            💳สลิป</a>
        </li>
        {curUserType == UserTypes.Employee && (
          <li className="nav-item">
            <a style={{ whiteSpace: "nowrap", padding: "6px 10px" }} className={classnames("nav-link tab-header", { "active": activeTabErp })} href="#" onClick={() => onTabClick(USER_DETAILS_TABS.ERP)}>
              {/* <i className='bx bx-doughnut-chart'></i>  */}
              🪟ERP</a>
          </li>
        )}
        <li className="nav-item">
          <a style={{ whiteSpace: "nowrap", padding: "6px 10px" }} className={classnames("nav-link tab-header", { "active": activeTabSearch })} href="#" onClick={() => onTabClick(USER_DETAILS_TABS.SEARCH)}>
            🔍ค้นหา</a>
        </li>
        {/* <li className="nav-item">
          <a className="nav-link" href="#">
            Menu 2
          </a>
        </li>
        <li className="nav-item">
          <a className="nav-link" href="#">
            Menu 3
          </a>
        </li> */}
      </ul>
    )
  }

  return (
    <>
      <div
        className={classnames("user-profile-sidebar", {
          "d-block": isOpenUserDetails,
        })}
      >
        {/* {curUserType == UserTypes.Employee && ( */}
        <div className="d-flex justify-content-between align-items-center">
          <ToggleButton />
          <i className="fz-15 bx bx-x d-none d-md-block hand" style={{ paddingRight: "10px" }} onClick={onCloseUserDetails} ></i> {/* Example icon */}
          <i className="fz-15 bx bx-left-arrow-alt d-block d-md-none hand" style={{ paddingRight: "10px" }} onClick={onCloseUserDetails}></i> {/* Example icon */}
        </div>
        {/* )} */}

        {/* tab profile */}
        <div className="position-relative" style={{ display: activeTabProfile ? "" : "none" }}>
          {getUserDetailsLoading && <Loader />}

          <ProfileUser
            onCloseUserDetails={onCloseUserDetails}
            chatUserDetails={chatUserDetails}
            onOpenVideo={onOpenVideo}
            onOpenAudio={onOpenAudio}
          />
          {/* <!-- End profile user --> */}

          {/* <!-- Start user-profile-desc --> */}
          <AppSimpleBar className="p-4 user-profile-desc">
            {" "}
            {/* simplebar */}


            {/* <Actions
              chatUserDetails={chatUserDetails}
              onOpenVideo={onOpenVideo}
              onOpenAudio={onOpenAudio}
              onToggleFavourite={onToggleFavourite}
              onToggleArchive={onToggleArchive}
            /> */}


            {/* <Status about={chatUserDetails.about} /> */}

            {!isChannel ? (
              <>
                <BasicDetails chatUserDetails={chatUserDetails} />
                <hr className="my-3" />
                <Groups chatUserDetails={chatUserDetails} />
                <hr className="my-3" />
              </>
            ) : (
              <>
                {chatUserDetails.contactType === UserTypes.Group && (
                  <>
                    <InviteCode chatUserDetails={chatUserDetails} />
                    <hr className="my-3" />
                  </>
                )}

                <Members chatUserDetails={chatUserDetails} />
                <hr className="my-3" />
              </>
            )}


            {/* <Media media={chatUserDetails.media} limit={3} />
            <hr className="my-4" />
            <AttachedFiles attachedFiles={chatUserDetails.attachedFiles} /> */}
          </AppSimpleBar>
          {/* <!-- end user-profile-desc --> */}

          {isOpenAudioModal && (
            <AudioCallModal
              isOpen={isOpenAudioModal}
              onClose={onCloseAudio}
              user={chatUserDetails}
            />
          )}
          {/*
          {isOpenVideoModal && (
            <VideoCallModal
              isOpen={isOpenVideoModal}
              onClose={onCloseVideo}
              user={chatUserDetails}
            />
          )} */}
        </div>

        {/* tab slip */}
        <div style={{ display: activeTabSlip ? "contents" : "none" }}>
          {activeTabSlip && <ContentUploadSlipCore allowEdit={false} />}
        </div>

        {/* tab erp */}
        <ErpTopics display={activeTabErp} customerId={chatUserDetails.companyId} groupType={chatUserDetails.contactType}></ErpTopics>
        <SearchChats display={activeTabSearch}></SearchChats>

      </div>
    </>
  );
};

export default Index;
